import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Roboto',
  fonts: [
    { src: '/public/assets/fonts/Roboto-Regular.ttf', fontWeight: 'normal' },
    { src: '/public/assets/fonts/Roboto-SemiBold.ttf', fontWeight: 'bold' },
  ],
});

export const ConsolidatedReportStyles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    padding: 10,
    fontSize: 8,
    fontFamily: 'Roboto',
  },

  // Header styles
  headerTitle: {
    backgroundColor: '#FF8C42',
    color: 'black',
    textAlign: 'center',
    padding: 8,
    fontSize: 12,
    fontWeight: 'bold',
    borderBottomWidth: "1px",
    borderColor: '#000',
  },

  vendorRow: {
    textAlign: 'center',
    padding: 6,
    fontSize: 10,
    borderBottomWidth: "1px",
    borderColor: '#000',
    borderTopWidth: 0,
  },

  subHeaderRow: {
    textAlign: 'center',
    fontSize: 9,
    padding: 4,
    borderColor: '#000',
    borderBottomWidth: "1px",
    borderTopWidth: 0,
  },

  // Table styles
  tableContainer: {
    borderWidth: 1,
    borderColor: '#000',
    marginTop: 6,
  },

  tableRow: {
    flexDirection: 'row',
  },

  centerCell: {
  justifyContent: 'center', 
  alignItems: 'center',     
  textAlign: 'center',     
},
  tableCell: {
    borderBottomWidth: "1px",
    padding: 4,
    fontSize: 8,
    minHeight: 18.4,
    justifyContent: 'center',
    alignItems: 'flex-start',
  },

  // Column widths - Fixed proportions
  col1: { width: '22.8%',borderRightWidth: '1px' },
  col2: { width: '35.5%',borderRightWidth: '1px' },
  col3: { width: '45.5%',borderRightWidth: '1px' },
  col4: { width: '40%' },


  fcol1: { width: '16%',borderRightWidth: '1px' },
  fcol2: { width: '25%',borderRightWidth: '1px' },
  fcol3: { width: '15%',borderRightWidth: '1px' },
  fcol4: { width: '17%',borderRightWidth: '1px' },
  fcol5: { width: '12%',borderRightWidth: '1px' },
  fcol6: { width: '16%' },

  // Full width columns
  fullWidth: { width: '100%' },
  halfWidth: { width: '50%' },
  wideCol: { width: '84.15%' },
  narrowCol: { width: '15.85%' },

  // Special cells
  grayCell: {
    backgroundColor: '#BFBFBF',
  },

  centerText: {
    textAlign: 'center',
  },

  leftText: {
    textAlign: 'left',
  },

  // Checkbox styles
  checkboxRow: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 8,
  },

  checkboxItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 8,
    marginBottom: 2,
  },

  checkbox: {
    width: 9,
    height: 9,
    borderWidth: 1,
    borderColor: '#000',
    marginRight: 3,
  },

  checkedBox: {
    backgroundColor: 'black',
  },

  checkmark: {
  color: 'black',
  fontSize: 7,
  fontWeight: 'bold',
  lineHeight: 10,
  },

  aboveSign:{
    height: "10px",
    width: "100%",
    backgroundColor: "#BFBFBF",
  },
  // Signature section
  signatureSection: {
    // marginTop: 10,
    borderWidth: 1,
    borderColor: '#000',
    borderRightWidth:0,
    borderLeftWidth:0,
    borderBottomWidth:0
  },

  signatureHeader: {
    backgroundColor: '#F5F5F5',
    textAlign: 'center',
    padding: 6,
    fontSize: 10,
    borderBottomWidth: 1,
    borderBottomColor: '#000',
  },

  signatureRow: {
    flexDirection: 'row',
  },

  signatureCell: {
    width: '50%',
    minHeight: 50,
    borderWidth: 0.5,
    borderColor: '#000',
    borderTopWidth: 0,
    borderBottomWidth: 0,
  },

    signatureCell1: {
    width: '50%',
    borderWidth: 0.5,
    borderColor: '#000',
    borderTopWidth: 0,
    borderBottomWidth: 0,
  },

  signatureCellLeft: {
  },

  signatureCellRight: {
  },

  signatureText: {
    fontSize: 9,
    textAlign: 'center',
    // marginBottom: 15,
  },

  signatureLine: {
    fontSize: 9,
    textAlign: 'center',
    fontFamily: 'Roboto',
  },

  signDatealign : {
    marginTop: "30px",
  },

  // Multi-line cell content
  cellContent: {
    width: '100%',
  },
});